/* jshint eqnull:true */
define([
	"require",
	"jquery",
	'wcs.alert',
	"wcs.context",
	'shared.main.plugins',
	"jquery.validate",
	'datalayer.wcs.my-account',
	'promise!wcs.zmetrics'
], function(require, $, DialogAlert, context, pluginLoader) {

    function resetForm($form) {
			$form.each(function(){
	    	this.reset();
    	});
    }

	function handlePageScroll(dataObject){
		var isPhoneEmailValidationEnable = $('.myaccount-profile-form-js').data('fieldMatchErrorEnabled');
		var phoneField=$('.address-form-phone-input');
		var phoneLabel=$('.profile-form-phone-label');
		var errorMsgPhoneSpan=$('div.myaccount-profile-phone-input-duplicate-error');

		if($('div').hasClass('alert-notification-message')) {
			if ($(".error").text().length > 0) {
				window.scrollTo(0, 0);
			}
		}

		if(isPhoneEmailValidationEnable && dataObject.hasClass('message error')) {
			errorMsgPhoneSpan.removeClass('hide');
			phoneField.removeClass('valid');
			phoneField.addClass('input-validation-error');
			phoneLabel.addClass('validation-error');
			phoneField.focus();
			phoneField.nextAll('span').removeClass('valid');
		}else{
			errorMsgPhoneSpan.addClass('hide');
			phoneField.removeClass('input-validation-error');
			phoneLabel.removeClass('validation-error');
		}
	}

    function submitAddressVerification($form){

    	// Show Processing Message
		DialogAlert.showLoadingNotification('p');

		//handle form logic
		$.ajax({
            type: "POST",
            url: "VFCLoyaltyProfileAVSAjax",
            data: $form.serialize(),
            dataType: "json",
            traditional: false,
            success: function(data){

				//set parameters
				var loyaltyParamPrefix = '&loyaltyAVS';
				var loyaltyAddressIdParam = loyaltyParamPrefix + 'SuggestedAddressId=';
				var loyaltyAddressErrorParam = loyaltyParamPrefix + 'Error=';
				//get URL
				var $loyaltyURLElement = $form.find('input[name=URL]');
				var loyaltyURL = $loyaltyURLElement.val();
				//reset URL
				var loyaltyURLNew = loyaltyURL.split(loyaltyParamPrefix)[0];

				//if address verification is enabled
				if (data.loyaltyAVSEnabled) {

					//if there's an error, append URL
					if (data.loyaltyAVSError) {
						var loyaltyVerfifyAddressURLError = loyaltyURLNew + loyaltyAddressErrorParam + data.loyaltyAVSError;

						$loyaltyURLElement.val(loyaltyVerfifyAddressURLError);
					// if we have a new address, append and populate
					} else if (data.loyaltyAVSSuggestedAddressId) {
						var loyaltyVerfifyAddressURL = loyaltyURLNew + loyaltyAddressIdParam + data.loyaltyAVSSuggestedAddressId;

						$loyaltyURLElement.val(loyaltyVerfifyAddressURL);
						$form.find('#loyaltyAddress1').val(data.loyaltyAddress1);
						$form.find('#loyaltyAddress2').val(data.loyaltyAddress2);
						$form.find('#loyaltyCity').val(data.loyaltyCity);
						$form.find('#loyaltyState option[value="' + data.loyaltyState +'"]').prop("selected", true);
						$form.find('input[name=loyaltyPostalCode]').val(data.loyaltyPostalCode);
					}
					$form.find('input[name=address_isvalid]').val(data.address_isvalid);
				}

				submitForm($form);
				
			},

			error: function(data){
				submitForm($form);
			}
		});
	}

	function submitForm($form){
		// Show Processing Message
		DialogAlert.showLoadingNotification('p');

		// Hide Previous Message
        $('.page-message-text').addClass('hide');

		//handle form logic
		$.ajax({
            type: "POST",
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: "html",
            traditional: false,
            success: function(data){
            	// Hide Processing Message
            	DialogAlert.hideLoadingNotification();

            	var $smsEnroll = $('#myaccount-sms-enrollment-hidden');

            	// handle sms opt in/out
	            if($('#myaccount-sms-enrollment-checkbox').is(':checked')) {
					$smsEnroll.val('true');
				} else {
					$smsEnroll.val('false');
				}
	            // always copy from mobilePhone so number can be unsubscribed properly
	            $('#myaccount-sms-enrollment-old-mobile-number').val($('#mobilePhone').val());

                // handle success or error messages
				$form.find('.form-notification-js').html(data);

				var changePasswordForm = $form.hasClass('myaccount-profile-password-form');

				//Reset Password Inputs Only
				if(changePasswordForm) {
					resetForm($form);
					var $successIcon = $form.find('.form-success-icon');
					var $successIconPassword = $form.find('.myaccount-registration-password-requirement');
					if ($successIcon && $successIcon.length > 0) {
						$successIcon.removeClass('valid');
					}
					if ($successIconPassword && $successIconPassword.length > 0) {
						$successIconPassword.removeClass('valid');
					}
				}

				// Check for Loyalty program DOB update
				var loyaltyDatePicker = $form.find('.birthDate[data-loyalty-datepicker]');
				if(loyaltyDatePicker.length > 0) {
					loyaltyDatePicker.prop('disabled', true).removeClass("valid");
				}

				var emailSubText=$(data).filter('.email-SubText').val();
				if(emailSubText != null && $("#ajax-messaging-email").length)
				document.getElementById("ajax-messaging-email").innerHTML=emailSubText; //$(data).filter('.email-SubText').val();

				// BEGIN - Code for loyalty sign up cookie refresh
				var loyaltyOptIn = $(data).filter('.loyalty-opt-in-js').val();
				var loyaltySignupSuccessful = $(data).filter('.loyalty-signup-response-js').val();
				var storeId = context.getStoreId();
				var scrollToElement = '.form-notification-js';
				var fixedSmallHeader = $('.header-container .fixed-small');
				var fixedMediumHeader = $('.header-container .fixed-medium');
				var offset;

				if (loyaltyOptIn == '1') {
					if (loyaltySignupSuccessful == 'true') {
						var loyaltyOptInCookie = "LOYALTY_OPT_IN" + context.getStoreId();
						context.setCookie(loyaltyOptInCookie, loyaltyOptIn);
						var loyaltyRedirectUrl = $form.attr('data-loyalty-redirect-url');
						if (loyaltyRedirectUrl && loyaltyRedirectUrl.length > 0) {
							window.location.href = loyaltyRedirectUrl;
						}
					} else {
						$('#loyalty-program-register').attr('checked', false);

						// Loyalty confirmation message is displayed in a different element than other messages
       					scrollToElement = '#loyalty-program-register';
					}
				}

				if (fixedSmallHeader.length || fixedMediumHeader.length) {
					offset = Math.max( 0, fixedSmallHeader.outerHeight(), fixedMediumHeader.outerHeight());
				} else {
					offset = 0;
				}

				$(window).scrollTop($form.find( scrollToElement ).offset().top - offset);

				// END - Code for loyalty sign up cookie refresh
				var $loyaltyEnrollmentCB = $form.find('.rewards-program-action-register-js');
				if ($loyaltyEnrollmentCB.length >0 && $loyaltyEnrollmentCB.is(':checked') && data.indexOf("error") < 0) {
					var $enrollmentSubscribeText = $form.find('.rewards-enrollment-message-text');
					if ($enrollmentSubscribeText.length > 0) {
						$form.find('.profile-rewards-enrollment-container').addClass('hide');
						$form.find('.loyalty-program-enrollment-message-success-text-container').removeClass('hide');
					}
				}
				
				var dobFieldEnablement = $('.profile .dob-textfield-js').data('editable');
				var dobInput=$('.myaccount-profile-dob-input');
				if(!dobFieldEnablement) {
					if(!$('.loyalty-program rewards-program').hasClass('hide')){
						if (dobInput.val()) {
							dobInput.prop('disabled', true);
						}else {
							dobInput.prop('disabled', false);
						}
					}

					if (!$('.rewards-program-action-register-js').is(':checked')) {
						dobInput.prop('disabled', true);
					}
				}

				if($form.length > 0 && data.indexOf("error") < 0){

					var extraParam 		 = $form[0].gender.value + "-_-" + $form[0].dob.value,
						logonTrackParams = {customerId: $form[0].customerId.value, email: $form[0].logonId.value, extra: extraParam};

					if(WCS_CONFIG.get("global::triggerEventsByGTM")){
						$.pubsub('publish', 'TRACK_USER_LOGIN', logonTrackParams);
					} else {
						zm.trackLogin(logonTrackParams);
					}
				} else {
					//Track submit errors
					var pubSubObj = {
						'event': 'submit-error',
						'message': $(data).text()
					};
					handlePageScroll($(data));
					$.pubsub('publish', 'vfdp.wcs.profile_event', pubSubObj);
				}
			},
			error: function(data){
				//not handling server error
			}
		});
	}

	$(window).ready(function () {
		var firstTimeSubmission = true;
		var emailSignupInput = $('.profile .myaccount-email-subscribe');
		var trackFields = $('.profile input, .profile select');
		var dobFieldEnablement = $('.profile .dob-textfield-js').data('editable');
		var $enrollmentCheckbox = $('.profile .rewards-program-action-register-js');
		var $joinNowButton = $('.myaccount-profile-loyalty-optin');
		if ($joinNowButton.length) {
			if ($enrollmentCheckbox.is(':checked')) {
				$joinNowButton.prop('disabled', false);
			} else {
				$joinNowButton.prop('disabled', true);
			}
		}

		$enrollmentCheckbox.on('click', function () {
			if(!dobFieldEnablement) {
				var zipCodeInput= $('.myaccount-profile-form-zipcode-input'),
					phoneInput=$('.address-form-phone-input'),
					dobInput=$('.myaccount-profile-dob-input');

					phoneInput.focusout();
				
				if ($(this).is(':checked')) {
					zipCodeInput.prop('disabled', false);
					phoneInput.prop('disabled', false);
					if ($joinNowButton.length) {
						$joinNowButton.prop('disabled', false);
					}
					validateDOB();
				} else {
					zipCodeInput.prop('disabled', true);
					phoneInput.prop('disabled', true);
					dobInput.prop('disabled', true);
					if ($joinNowButton.length) {
						$joinNowButton.prop('disabled', true);
					}
				}
			}
		});
		
		if ($('#previous-subscription-value-js')) {
			emailSignupInput.on('click' , function(event) {
				if (emailSignupInput.prop('checked')) {
					$(this).parents('form').find('#previous-email-signup-1-js').remove();
				} else {
					$(this).parents('form').prepend('<input type="hidden" name="receiveEmail" value="false" id="previous-email-signup-1-js" />');
				}
			});
		}

		$('.profile .submit-button-js').on('click', function (event){
			event.preventDefault();
			
			var $isLoyalityEnrolled = $('.profile .rewards-enrollment-message-text');
			if ($isLoyalityEnrolled.length > 0 && !dobFieldEnablement) {
				$('.address-form-phone-input').focusout();
			}

			var $form = $(this).parents('form'),
				pubSubObj = {
					'event': 'click-submit'
				};
			$.pubsub('publish', 'vfdp.wcs.profile_event', pubSubObj);

			if ($form.valid()) {
				if ($form.is('[data-avs-enabled]')) {
					submitAddressVerification($form);
				} else {
					submitForm($form);
				}
			}
		});

		// Track clicks on profile tooltips
		$('.profile .tooltip-js').on('click', function() {
			var pubSubObj = {
				'event': 'click-link',
				'field': $.trim($(this).parent().prev().text()),
				'type': 'tooltip'
			};
			$.pubsub('publish', 'vfdp.wcs.profile_event', pubSubObj);
		});

		//Track clicks on profile fields
		trackFields.on('focus', function() {

			var $this = $(this),
				pubSubObj = {
					'event': 'click-field',
					'field': $this.attr('name'),
					'type': $this.attr('type')
				};
			$.pubsub('publish', 'vfdp.wcs.profile_event', pubSubObj);
		});

		//Track inline errors on profile fields
		trackFields.on('blur', function() {
			var $this = $(this);
			if ($this.hasClass('error')) {
				var pubSubObj = {
						'event': 'inline-error',
						'field': $this.attr('name'),
						'type': $this.attr('type'),
						'message': $this.siblings('div.error').children('span').text()
					};
				$.pubsub('publish', 'vfdp.wcs.profile_event', pubSubObj);
			}
		});

		pluginLoader.loadPlugins([{
			name: 'shared.responsive-datepicker',
			selector: '.responsive-datepicker-js',
			initFunction: 'responsiveDatepicker'
		}, {
			name: 'wcs.realtime-password-validation',
			selector: '.myaccount-input-validation-rules-enabled',
			initFunction: 'realtimePasswordValidation'
		}]);

		if ($('#loyaltyAddress1').hasClass('loyalty-profile-autocomplete-form-address-field-js')) {
            pluginLoader.loadPlugins({
                name: 'wcs.google-address-autocomplete',
                selector: '.profile',
                initFunction: 'addressAutoComplete'
            });
        }

		$('.myaccount-sms-form-js .sms-promotions-js').on('click' , function() {
			var form = $(this).parents('form');
			if($(this).is(':checked')) {
				form.children('.sms-promo-js').remove();
			} else {
				form.prepend('<input type="hidden" name="receiveSMS" class="sms-promo-js" value="false">');
			}
		});
		$('.myaccount-sms-form-js .sms-notifications-js').on('click' , function() {
			var form = $(this).parents('form');
			if($(this).is(':checked')) {
				form.children('.sms-notification-js').remove();
			} else {
				form.prepend('<input type="hidden" name="receiveSMSNotification" class="sms-notification-js" value="false">');
			}
		});

		var $smsForm = $('#myaccountSMSForm'),
		$addSMSSubscription = $('#addSMSSubscription'),
		$updateSMSSubscription = $('#updateSMSSubscription'),
		$phoneToUpdateSubscribe = $('input[name=phoneToUpdateSubscribe]'),
		$phoneToUnSubscribe = $('input[name=phoneToUnSubscribe]'),
		$newSubscriptionOnly = $('input[name=newSubscriptionOnly]'),
		$updateSubscriptionOnly = $('input[name=updateSubscriptionOnly]'),
		$phoneToSubscribe = $('#phoneToSubscribe'),
		$unSubscriptionOnly = $('input[name=unSubscriptionOnly]'),
		$smsNotifications = $('#sms-notifications'),
		$smsTermsConditionModal = $('#smsTermsConditionModal');

		$smsTermsConditionModal.on('closed.zf.reveal', function(event) {
			$smsNotifications.prop('checked', false);
		});

		$('.myaccount-sms-preferences-submit-button').off().on('click', function (event) {
			event.preventDefault();

			if ($smsForm.valid()) {
				DialogAlert.showLoadingNotification();
				$('.form-notification-js').html("");

				if (event.target.name === 'buttonUnSub' || event.target.parentNode.name === 'buttonUnSub') {
					$unSubscriptionOnly.val('true');
				}

				$.ajax({
					url: $smsForm.attr('action'),
					data: $smsForm.serializeArray(),
					type: 'POST'
				}).done(function(response) {
					if(response.success) {
						if (response.newSubscriptionOnly && response.newSubscriptionOnly.length && (response.newSubscriptionOnly[0] == 'true')) {
							$addSMSSubscription.addClass("hide");
							$updateSMSSubscription.removeClass("hide");
							$phoneToUpdateSubscribe.val(response.phoneToSubscribe[0]);
							$phoneToUnSubscribe.val(response.phoneToSubscribe[0]);
							$newSubscriptionOnly.val('');
							$updateSubscriptionOnly.val('true');
							$phoneToUpdateSubscribe.attr("required", true);
						} else if (response.updateSubscriptionOnly && response.updateSubscriptionOnly.length && (response.updateSubscriptionOnly[0] == 'true') && (response.unSubscriptionOnly[0] == 'true')) {
							$addSMSSubscription.removeClass("hide");
							$updateSMSSubscription.addClass("hide");
							$phoneToSubscribe.val($phoneToSubscribe.data('formatAsYouType'));
							$newSubscriptionOnly.val('true');
							$updateSubscriptionOnly.val('');
							$unSubscriptionOnly.val('');
							$smsNotifications.prop('checked', false);
							$smsNotifications.prop('disabled', true);
						} else if (response.updateSubscriptionOnly && response.updateSubscriptionOnly.length && (response.updateSubscriptionOnly[0] == 'true') && (response.unSubscriptionOnly[0] == '')) {
							$phoneToUnSubscribe.val(response.phoneToUpdateSubscribe[0]);
						}
					} else {
						// handle error scenario
						$smsForm.find('.form-notification-js').html(response);
					}
				}).fail(function(response){
					DialogAlert.showPageNotification(LANG_MSG.GENERIC_ERROR_MESSAGE, 'error');
				}).always(function(){
					DialogAlert.hideLoadingNotification();
				});
			}
		});

		$phoneToSubscribe.on('blur', function() {
			var $this = $(this);
			if ($this.hasClass('error') || $this.val() == $this.data('formatAsYouType')) {
				$smsNotifications.prop('disabled', true);
				$smsNotifications.prop('checked', false);
			} else {
				$smsNotifications.removeAttr('disabled', false);
			}
		});

		var $subscribedPhoneStatus = $('input[name=subscribedPhoneStatus]').val();
		if ($subscribedPhoneStatus && ($subscribedPhoneStatus == 'true' || $subscribedPhoneStatus === true)) {
			$addSMSSubscription.addClass("hide");
			$updateSMSSubscription.removeClass("hide");
			$phoneToSubscribe.val($phoneToUpdateSubscribe.val());
			$updateSubscriptionOnly.val('true');
		} else {
			$addSMSSubscription.removeClass("hide");
			$updateSMSSubscription.addClass("hide");
			$newSubscriptionOnly.val('true');
			$phoneToUnSubscribe.val('');
			$phoneToUpdateSubscribe.val('');
		}

		var $formBillingAddress = $('.shipping-form.address-form');
		if ($formBillingAddress.length > 0) {
			var $pageName = $formBillingAddress.find('input[name="pageName"]');
			if ($pageName.length > 0 && $pageName.val() === 'billing') {
				$formBillingAddress.find('input[name="firstName"]').trigger('focus');
			}
		}

		function initMultiSelect() {
			var multiSelect = $('.multi-image-selector');
			if(multiSelect.length > 0) {
				require(['wcs.loyalty-multiselect'],function(LoyaltyMultiSelect) {
					multiSelect.loyaltyMultiSelect();
				});
			}
		}

		function initShoeSizeSelector() {
			var shoeSelector = $('.loyalty-shoe-size-selector');
			if(shoeSelector.length > 0) {
				require(['wcs.loyalty-shoe-size-selector'],function(LoyaltyShoeSizeSelector) {
					shoeSelector.loyaltyShoeSizeSelector({});
				});
			}
		}

		function initDatePicker() {
			var datePicker = $('.birthDate[data-loyalty-datepicker]');
			if(datePicker.length > 0) {
				require(['wcs.loyalty-date-picker'],function(LoyaltyDatePicker) {
					datePicker.loyaltyDatePicker();
				});
			}
		}

		function validateDOB() {
			var dobField = $('.profile .dob-textfield-js');

			if (dobField.val()) {
				dobField.prop('disabled', true);
			}else {
				dobField.prop('disabled', false);
			}
		}

		initMultiSelect();
		initShoeSizeSelector();
		initDatePicker();
	});
	return {
		submitForm: submitForm
	};
});